import { useCallback, useState } from 'react';

export interface UseSeriesVisibilityOptions {
  onSeriesToggle?: (seriesId: string, wasHidden: boolean) => void;
}

export interface UseSeriesVisibilityResult {
  hiddenSeriesIds: Set<string>;
  removedSeriesIds: Set<string>;
  handleSeriesToggle: (seriesId: string, wasHidden: boolean) => void;
  removeSeriesIds: (ids: string[]) => void;
}

export const useSeriesVisibility = ({
  onSeriesToggle,
}: UseSeriesVisibilityOptions): UseSeriesVisibilityResult => {
  const [hiddenSeriesIds, setHiddenSeriesIds] = useState<Set<string>>(
    () => new Set()
  );
  const [removedSeriesIds, setRemovedSeriesIds] = useState<Set<string>>(
    () => new Set()
  );

  const handleSeriesToggle = useCallback(
    (seriesId: string, wasHidden: boolean) => {
      setHiddenSeriesIds(prev => {
        const next = new Set(prev);

        if (wasHidden) {
          next.delete(seriesId);
        } else {
          next.add(seriesId);
        }

        return next;
      });
      onSeriesToggle?.(seriesId, wasHidden);
    },
    [onSeriesToggle]
  );

  const removeSeriesIds = useCallback((ids: string[]) => {
    if (ids.length === 0) {
      return;
    }

    setRemovedSeriesIds(prev => {
      const next = new Set(prev);

      ids.forEach(id => next.add(id));
      return next;
    });
  }, []);

  return {
    hiddenSeriesIds,
    removedSeriesIds,
    handleSeriesToggle,
    removeSeriesIds,
  };
};
